import React from 'react';
import styled from '@emotion/styled';
import { Icon, NakedButton } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

const StyledButton = styled(NakedButton)`
  width: ${themeGet('space.9')};
  height: ${themeGet('space.9')};
  color: ${themeGet('colors.text.body')};
  font-size: ${themeGet('fontSizes.sm')};
  line-height: ${themeGet('space.6')};

  &:disabled,
  &:disabled:focus,
  &:disabled:hover {
    color: ${themeGet('colors.greys.smoke')};
    opacity: 1;
  }

  &.active,
  &.active:focus,
  &.active:hover {
    color: ${themeGet('colors.white')};
    border-radius: 50%;
    background-color: ${themeGet('colors.text.body')};
    opacity: 1;
  }
`;

const PaginationItem = ({ item }) => {
  const normalizedIcons = {
    previous: 'chevronLeft',
    next: 'chevronRight',
  };
  return (
    <StyledButton
      className={item.selected && 'active'}
      onClick={item.onClick}
      type="button"
      disabled={item.disabled}
    >
      {item.type === 'page' && item.page}
      {normalizedIcons[item.type] && (
        <Icon name={normalizedIcons[item.type]} size="32px" />
      )}
    </StyledButton>
  );
};

PaginationItem.propTypes = {
  item: PropTypes.shape({
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    selected: PropTypes.bool,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default PaginationItem;
